import React from 'react';
import { ViewSubcategoryState } from './viewSubcategoryState/ViewSubcategoryState';
import { ViewForm } from './components/ViewForm';
import { ModalWindows } from './components/ModalWindows';

export const ViewSubcategoryPageV2: React.FC = () => {
	return (
		<ViewSubcategoryState>
			<ViewForm />
			<ModalWindows />
		</ViewSubcategoryState>
	);
};
